var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',_vm._l((_vm.filters),function(filter){return _c('v-col',{key:filter.filtername,attrs:{"cols":"2"}},[_c('column-filter-view',{attrs:{"filter":filter},on:{"removeFilter":_vm.removeFilter}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }